<template>
  <b-modal v-model="visibleModal" :width="400"  animation="zoom-out">
    <div class="model-card">

      <header class="modal-card-head">
        <p class="modal-card-title">Confirmation</p>
        <button @click="closeModal" type="button" class="delete"></button>
      </header>

      <div class="modal-card-body">
        <div class="content pt-2">
          <p style="color: #393953; text-align: left">Do you want to decline this document? </p>

          <footer>
            <div class="is-full column py-0 px-0">
              <div class="column">
                <div class="columns">
                  <div class="column"></div>
                  <div class="buttons">
                    <b-button @click="updatedocumentStatus()" type="is-warning is-small">Yes</b-button>
                    <b-button  type="is-danger is-small" @click="closeModal">No</b-button>
                  </div>
                </div>
              </div>
            </div>
          </footer>

        </div>
      </div>

    </div>
  </b-modal>
</template>

<script>
import axios from "axios";
export default {

  name:'decline-modal',

  props:['document_id','showModal'],

  data(){
    return{
      isLoading:true,
      visibleModal:false,
      docID:false,
    }
  },

  mounted() {
    this.visibleModal = this.showModal
    this.docID = this.document_id
  },

  methods:{

    closeModal(){
      this.visibleModal = false
      this.$emit('on-decline-close');
    },

    updatedocumentStatus:function (){
      const comp = this
      try {

        axios.post(comp.$base_url+'/customer/updateDocumentStatus', {
          document_id : comp.docID,
          invitee_token:comp.$root.invitee_token,
        })
            .then(function (response) {

              console.log("Pending Documents data ---------------")
              console.log(response)

              if(response.data.success){
                comp.$buefy.toast.open({
                  message: 'Document is Declined',
                  type: "is-success",
                });

                comp.closeModal()
                comp.$router.go(-1)
                comp.isLoading = false
              }
              else{
                comp.$buefy.toast.open({
                  message: "Something went wrong",
                  type: "is-danger",
                });
              }
            })
            .catch(function (error) {
              console.log(error)
              comp.$buefy.toast.open({
                message: "Something went wrong",
                type: "is-danger",
              });
            });

      }
      catch (e) {
        comp.$buefy.toast.open({
          message: "Something went wrong",
          type: "is-danger",
        });
        console.log("Exception occurred in Customer PendingPage  getPendingDocuments() : "+e.message)
      }

     },

  }
}
</script>